import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import Warning from "TaskDialogCommon/Warning";
import { HeroListCheckbox } from "TaskDialogCommon/HeroListCheckbox";
import {
  SkillSelectorList,
  skillnames,
} from "TaskDialogCommon/SkillSelectorList";
import { getLastConfigForTask } from "Utils/Common";

const getSelectedheroesFromData = (AccountDetailData) => {
  const selectedheroes = {};
  for (var key in AccountDetailData.heroes) {
    var cityObj = AccountDetailData.heroes[key];
    selectedheroes[cityObj.cityno] = [];
    for (var hkey in cityObj.cityheroes) {
      var heroObj = cityObj.cityheroes[hkey];
      selectedheroes[cityObj.cityno].push({
        name: heroObj.heroname,
        selected: false,
      });
    }
  }
  return selectedheroes;
};

const taskname = "skillenroller";

const getInitialStatFromLastConfig = (accountdetailrow, AccountDetailData) => {
  const taskConfig = {
    accountdetail: accountdetailrow,
    selectedheroes: getSelectedheroesFromData(AccountDetailData),
    skills: {
      s1: skillnames[0],
      s2: skillnames[0],
      s3: skillnames[0],
      s4: skillnames[0],
      s5: skillnames[0],
    },
  };
  try {
    var storeddata = getLastConfigForTask(taskname);
    if (storeddata) {
      for (var key in taskConfig.selectedheroes) {
        var cityObj = taskConfig.selectedheroes[key];
        var cityObjStored = storeddata.selectedheroes[key];
        for (var hkey in cityObj) {
          var heroObj = cityObj[hkey];
          var heroObjStored = cityObjStored[hkey];
          heroObj.selected = heroObjStored.selected;
        }
      }
      taskConfig.skills = { ...storeddata.skills };
    }
  } catch (e) {
    logger.log(e);
  }
  return taskConfig;
};

export default function(props) {
  const { AccountDetailData, accountdetailrow } = props;
  const [taskConfig, setTaskConfig] = React.useState(
    getInitialStatFromLastConfig(accountdetailrow, AccountDetailData)
  );

  const validate = () => {
    return true;
  };

  logger.log("Here", props, taskConfig);

  const setValue = (event, key) => {
    let value = event.target.value;
    setTaskConfig({ ...taskConfig, [key]: value });
  };

  return (
    <TaskDialog heading={"Hero Skill Enroller"}>
      <HeroListCheckbox
        label={"Select Hero/Heroes"}
        AccountDetailData={AccountDetailData}
        taskConfig={taskConfig}
        setValue={setValue}
        setTaskConfig={setTaskConfig}
        param={"selectedheroes"}
      />

      <SkillSelectorList
        label={"Select Skills"}
        AccountDetailData={AccountDetailData}
        taskConfig={taskConfig}
        setValue={setValue}
        setTaskConfig={setTaskConfig}
        param={"skills"}
      />
      <Warning>
        *Skills are order neutral, meaning if you select 1 BB2 in drop down 1,
        the task will NOT try to make sure that the 1st skill on each hero is
        BB2. It will just try to make sure that each hero has ONE BB2.
        <br />
        *For freedom of choice to the player, the allowed skill combinations is
        not filtered from task end. If you select 2 Breath of Life, the task
        will not stop you, it will still TRY to put 2 Breath of Life, but as we
        know there cant be two Breath of Life on single hero, it will fail.
        <br />
        *Task assumes you have enough Skill books for the heroes you have
        selected for the skills you have selected as well as the scrolls
        required to update them.
        <br />
        *Please make sure you have enough Skill books, have selected correct
        skill combinations and have enough Scrolls before running the task!
      </Warning>

      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Run"}
        validate={validate}
      />
    </TaskDialog>
  );
}
